import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="section w-full h-screen bg-off-black text-white-smoke snap-start snap-always"
    >
      <div className="flex flex-col justify-center items-center w-full h-full">
        <div className="max-w-[1000px] w-full grid grid-cols-2 gap-8">
          <div className="sm:text-right pb-8 pl-4">
            <p className="text-4xl font-bold inline border-b-4 border-yellow-green text-ebony">
              About
            </p>
          </div>
          <div></div>
        </div>
        <div className="max-w-[1000px] w-full grid sm:grid-cols-2 gap-8 px-4">
          <div className="sm:text-right text-4xl font-bold text-white-smoke">
            <p>
              Hey, I'm Gavin. Excited for you to discover how I can help you.
              Feel free to explore!
            </p>
          </div>
          <div>
            <p>
              I thrive on developing transformative software solutions that
              elevate the way we live and work. With a background in Enterprise
              Web Development and a diverse tech stack, I'm equipped to serve a
              wide range of clients—from solo entrepreneurs to established
              enterprises. What could you accomplish with a tech-savvy problem
              solver just a click away?
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
